// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Red_Hat_Display/static/RedHatDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Montserrat/static/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
html {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

@font-face {
  font-family: "big";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "paragraph";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
h1 {
  font-size: 80px;
  margin: 24px 0px;
  font-family: "big";
  text-align: center;
  color: rgb(69, 102, 124);
}

h2,
h3 {
  font-size: 40px;
  margin: 24px 0px;
  font-family: "big";
  text-align: center;
  color: rgb(69, 102, 124);
}

h4,
p,
a,
button,
label,
input {
  font-size: 24px;
  font-family: "paragraph";
  line-height: 1.6em;
}

button {
  margin: 16px 0px;
  padding: 8px 16px;
  border: 4px solid rgb(69, 102, 124);
  border-radius: 500px;
  background-color: white;
  color: rgb(31, 33, 26);
  transition: background-color 0.3s ease;
}
button:hover {
  cursor: pointer;
  background-color: rgb(69, 102, 124);
  color: rgb(241, 243, 255);
  transition: background-color 0.3s ease;
}

.mobile-only {
  display: none;
}

.down-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 24px;
  z-index: 2;
}
.down-btn .arrow {
  position: relative;
  height: 80px;
  width: 80px;
}
.down-btn .arrow .straight,
.down-btn .arrow .left,
.down-btn .arrow .right {
  position: absolute;
  display: inline-block;
  height: 2px;
  background-color: rgb(31, 33, 26);
}
.down-btn .arrow .straight {
  transform: rotate(90deg);
  top: 35px;
  left: 20px;
  width: 40px;
}
.down-btn .arrow .left {
  transform: rotate(45deg);
  top: 48px;
  left: 20px;
  width: 24px;
}
.down-btn .arrow .right {
  transform: rotate(-45deg);
  top: 48px;
  right: 20px;
  width: 24px;
}
.down-btn:hover {
  cursor: pointer;
}

@media screen and (max-width: 980px) {
  h1 {
    font-size: 40px;
  }
  h2,
  h3 {
    font-size: 32px;
  }
  h4,
  p,
  a,
  button,
  label,
  input {
    font-size: 20px;
  }
  .mobile-only {
    display: flex;
  }
}
.popnavUl {
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  z-index: 119;
  overflow: visible;
}
.popnavUl * {
  background-color: transparent;
}
.popnavUl .navlinkStyle {
  text-decoration: none;
  color: rgb(31, 33, 26);
  position: relative;
  font-size: 20px;
  font-weight: bold;
  pointer-events: auto;
  transition: color 0.3s ease;
}
.popnavUl li {
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  width: 200px;
  height: 100%;
  padding: 8px;
  margin: 0px 8px;
  background-color: rgb(241, 243, 255);
  transition: background-color 0.3s ease;
}
.popnavUl li.profileLi {
  background-color: transparent;
}
.popnavUl li.profileLi img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border: 4px solid rgb(69, 102, 124);
  border-radius: 50px;
  background-color: rgb(241, 243, 255);
  transition: background-color 0.3s ease;
}
.popnavUl li.last {
  border: 4px solid rgb(69, 102, 124);
  border-radius: 500px;
  background-color: white;
  margin: 8px;
}
.popnavUl li.mobileOnly {
  display: none;
}
.popnavUl li:hover a {
  font-weight: bold;
  color: rgb(69, 102, 124);
}
.popnavUl li.last:hover {
  background-color: rgb(69, 102, 124);
  transition: background-color 0.3s ease;
}
.popnavUl li.last:hover .navlinkStyle {
  color: rgb(241, 243, 255);
  transition: color 0.3s ease;
}
.popnavUl li.profileLi:hover {
  background-color: transparent;
}
.popnavUl li.profileLi:hover img {
  background-color: rgb(69, 102, 124);
  transition: background-color 0.3s ease;
}
.popnavUl li:nth-of-type(n + 1) {
  margin-left: -0.8vw;
}

@media screen and (max-width: 980px) {
  .popnavUl {
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    transition: transform 0.3s ease-in-out;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: rgb(241, 243, 255);
  }
  .popnavUl.open {
    transform: translateX(0);
  }
  .popnavUl.close {
    transform: translateX(-100%);
  }
  .popnavUl li,
  .popnavUl li.last {
    height: -moz-fit-content;
    height: fit-content;
    margin: 2em 0;
    padding: 1em;
    clip-path: none;
    background-color: transparent;
  }
  .popnavUl li.mobileOnly,
  .popnavUl li.last.mobileOnly {
    display: flex;
  }
  .popnavUl li .navlinkStyle,
  .popnavUl li.last .navlinkStyle {
    color: rgb(31, 33, 26);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/components/navbar/popnav.scss"],"names":[],"mappings":"AASA;;EAEE,UAAA;EACA,SAAA;EACA,sBAAA;ACRF;;ADWA;EACE,kBAAA;EACA,4CAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;ACTF;ADYA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBA7Bc;ACmBhB;;ADaA;;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAtCc;AC4BhB;;ADaA;;;;;;EAME,eAAA;EACA,wBAAA;EACA,kBAAA;ACVF;;ADaA;EACE,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,oBAnDO;EAoDP,uBAAA;EACA,sBA3DW;EA4DX,sCAAA;ACVF;ADYE;EACE,eAAA;EACA,mCA/DY;EAgEZ,yBAlEU;EAmEV,sCAAA;ACVJ;;ADcA;EACE,aAAA;ACXF;;ADcA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;ACXF;ADaE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;ACXJ;ADaI;;;EAGE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,iCA9FO;ACmFb;ADcI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ACZN;ADeI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ACbN;ADgBI;EACE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;ACdN;ADkBE;EACE,eAAA;AChBJ;;ADoBA;EACE;IACE,eAAA;ECjBF;EDoBA;;IAEE,eAAA;EClBF;EDqBA;;;;;;IAME,eAAA;ECnBF;EDsBA;IACE,aAAA;ECpBF;AACF;AA5HA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA8HF;AA3HE;EACE,6BAAA;AA6HJ;AA1HE;EACE,qBAAA;EACA,sBDlBS;ECmBT,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,2BAAA;AA4HJ;AAzHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,oCDpCU;ECqCV,sCAAA;AA2HJ;AAzHI;EACE,6BAAA;AA2HN;AAzHM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mCAAA;EACA,mBAAA;EACA,oCDhDM;ECiDN,sCAAA;AA2HR;AAvHI;EACE,mCAAA;EACA,oBDhDG;ECiDH,uBAAA;EACA,WAAA;AAyHN;AAtHI;EACE,aAAA;AAwHN;AApHM;EACE,iBAAA;EACA,wBDjEQ;ACuLhB;AAlHI;EACE,mCDtEU;ECuEV,sCAAA;AAoHN;AAlHM;EACE,yBD5EM;EC6EN,2BAAA;AAoHR;AAhHI;EACE,6BAAA;AAkHN;AAhHM;EACE,mCDnFQ;ECoFR,sCAAA;AAkHR;AA7GE;EACE,mBAAA;AA+GJ;;AA3GA;EACE;IACE,wBAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;IACA,OAAA;IACA,MAAA;IACA,sCAAA;IACA,WAAA;IACA,YAAA;IACA,SAAA;IACA,UAAA;IACA,oCD7GU;EC2NZ;EA5GE;IACE,wBAAA;EA8GJ;EA3GE;IACE,4BAAA;EA6GJ;EA1GE;;IAEE,wBAAA;IAAA,mBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;IACA,6BAAA;EA4GJ;EA1GI;;IACE,aAAA;EA6GN;EA1GI;;IACE,sBDnIK;ECgPX;AACF","sourcesContent":["$light-color: rgb(241, 243, 255);\n$dark-color: rgb(31, 33, 26);\n$primary-color: rgb(69, 102, 124);\n$secondary-color: rgb(43, 45, 36);\n\n$mobile-width: 980px;\n\n$radius: 500px;\n\n*,\nhtml {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: \"big\";\n  src: url(\"../assets/fonts/Red_Hat_Display/static/RedHatDisplay-Medium.ttf\");\n}\n\n@font-face {\n  font-family: \"paragraph\";\n  src: url(\"../assets/fonts/Montserrat/static/Montserrat-Regular.ttf\");\n}\n\nh1 {\n  font-size: 80px;\n  margin: 24px 0px;\n  font-family: \"big\";\n  text-align: center;\n  color: $primary-color;\n}\n\nh2,\nh3 {\n  font-size: 40px;\n  margin: 24px 0px;\n  font-family: \"big\";\n  text-align: center;\n  color: $primary-color;\n}\n\nh4,\np,\na,\nbutton,\nlabel,\ninput {\n  font-size: 24px;\n  font-family: \"paragraph\";\n  line-height: 1.6em;\n}\n\nbutton {\n  margin: 16px 0px;\n  padding: 8px 16px;\n  border: 4px solid $primary-color;\n  border-radius: $radius;\n  background-color: white;\n  color: $dark-color;\n  transition: background-color 0.3s ease;\n\n  &:hover {\n    cursor: pointer;\n    background-color: $primary-color;\n    color: $light-color;\n    transition: background-color 0.3s ease;\n  }\n}\n\n.mobile-only {\n  display: none;\n}\n\n.down-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: 24px;\n  z-index: 2;\n\n  .arrow {\n    position: relative;\n    height: 80px;\n    width: 80px;\n\n    .straight,\n    .left,\n    .right {\n      position: absolute;\n      display: inline-block;\n      height: 2px;\n      background-color: $dark-color;\n    }\n\n    .straight {\n      transform: rotate(90deg);\n      top: 35px;\n      left: 20px;\n      width: 40px;\n    }\n\n    .left {\n      transform: rotate(45deg);\n      top: 48px;\n      left: 20px;\n      width: 24px;\n    }\n\n    .right {\n      transform: rotate(-45deg);\n      top: 48px;\n      right: 20px;\n      width: 24px;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n@media screen and (max-width: $mobile-width) {\n  h1 {\n    font-size: 40px;\n  }\n\n  h2,\n  h3 {\n    font-size: 32px;\n  }\n\n  h4,\n  p,\n  a,\n  button,\n  label,\n  input {\n    font-size: 20px;\n  }\n\n  .mobile-only {\n    display: flex;\n  }\n}\n","@import \"../../styles/main.scss\";\n\n.popnavUl {\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  z-index: 119;\n  overflow: visible;\n  // background-color: $light-color;\n\n  * {\n    background-color: transparent;\n  }\n\n  .navlinkStyle {\n    text-decoration: none;\n    color: $dark-color;\n    position: relative;\n    font-size: 20px;\n    font-weight: bold;\n    pointer-events: auto;\n    transition: color 0.3s ease;\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n    width: 200px;\n    height: 100%;\n    padding: 8px;\n    margin: 0px 8px;\n    background-color: $light-color;\n    transition: background-color 0.3s ease;\n\n    &.profileLi {\n      background-color: transparent;\n\n      img {\n        width: 72px;\n        height: 72px;\n        object-fit: cover;\n        border: 4px solid $primary-color;\n        border-radius: 50px;\n        background-color: $light-color;\n        transition: background-color 0.3s ease;\n      }\n    }\n\n    &.last {\n      border: 4px solid $primary-color;\n      border-radius: $radius;\n      background-color: white;\n      margin: 8px;\n    }\n\n    &.mobileOnly {\n      display: none;\n    }\n\n    &:hover {\n      a {\n        font-weight: bold;\n        color: $primary-color;\n      }\n    }\n\n    &.last:hover {\n      background-color: $primary-color;\n      transition: background-color 0.3s ease;\n\n      .navlinkStyle {\n        color: $light-color;\n        transition: color 0.3s ease;\n      }\n    }\n\n    &.profileLi:hover {\n      background-color: transparent;\n\n      img {\n        background-color: $primary-color;\n        transition: background-color 0.3s ease;\n      }\n    }\n  }\n\n  li:nth-of-type(n + 1) {\n    margin-left: -0.8vw;\n  }\n}\n\n@media screen and (max-width: $mobile-width) {\n  .popnavUl {\n    flex-flow: column nowrap;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    transition: transform 0.3s ease-in-out;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    background-color: $light-color;\n\n    &.open {\n      transform: translateX(0);\n    }\n\n    &.close {\n      transform: translateX(-100%);\n    }\n\n    li,\n    li.last {\n      height: fit-content;\n      margin: 2em 0;\n      padding: 1em;\n      clip-path: none;\n      background-color: transparent;\n\n      &.mobileOnly {\n        display: flex;\n      }\n\n      .navlinkStyle {\n        color: $dark-color;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
